import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@material-ui/core/MenuItem';
// common components
import FormField from './../../../common/Forms/FormField/FormField';
import Pickers from './../../../common/Forms/Pickers/Pickers';

const ManageBatch = ({ onDelete, onChange, value, onChangePicker, courseList }) => {
    if (onDelete) {
        return (
            <div className='ManageBatch'>
                <div>Are you sure, you want to delete?</div>
            </div>
        );
    }
    return (
        <div className='ManageBatch'>
            <div className="half">
                <div>
                    <FormField
                        select
                        label="course"
                        name="course_id"
                        value={JSON.stringify(value.course_id)}
                        onChange={onChange}
                        validate={['required']}
                    >
                        {courseList && courseList.map(item =>
                            item.active==='Y'&&<MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>)
                        }
                    </FormField>
                </div>
                <div>
                    <FormField
                        label="batch Name"
                        name="name"
                        type="text"
                        placeholder="enter batch name"
                        value={value.name}
                        onChange={onChange}
                        validate={['required']}
                        autoFocus
                        maxLength={50}
                    />
                </div>
            </div>
            <FormField
                label="description"
                name="description"
                type="text"
                // multiline
                placeholder="enter description"
                value={value.description}
                onChange={onChange}
                validate={['required']}
            />
            <div className="half">
                <div>
                    <FormField
                        label="country"
                        name="country"
                        type="text"
                        placeholder="enter country"
                        value={value.country}
                        onChange={onChange}
                        validate={['required']}
                        maxLength={50}
                    />
                </div>
                <div>
                    <FormField
                        label="city"
                        name="city"
                        type="text"
                        placeholder="enter city"
                        value={value.city}
                        onChange={onChange}
                        validate={['required']}
                        maxLength={50}
                    />
                </div>
            </div>
            <div className="half">
                <div>
                    <Pickers
                        datepicker
                        label="start date"
                        value={value.start_date}
                        onChange={(value) => onChangePicker('start_date', value)}
                    />
                </div>
                <div>
                    <Pickers
                        datepicker
                        label="end date"
                        minDate={value.start_date}
                        value={value.end_date}
                        onChange={(value) => onChangePicker('end_date', value)}
                    />
                </div>
            </div>
            {/* <Pickers
                timepicker
                label="start time"
                value={value.start_time}
                onChange={(value) => onChangePicker('start_time', value)}
            />
            <Pickers
                timepicker
                label="end time"
                value={value.end_time}
                onChange={(value) => onChangePicker('end_time', value)}
            /> */}
        </div>
    );
}

ManageBatch.propTypes = {
    onDelete: PropTypes.bool,
    onChange: PropTypes.func,
    value: PropTypes.instanceOf(Object),
    courseList: PropTypes.instanceOf(Array),
    onChangePicker: PropTypes.func
};

ManageBatch.defaultProps = {
    onDelete: false,
    onChange: () => { },
    value: {},
    courseList: [],
    onChangePicker: () => { }
};

export default ManageBatch;


// WEBPACK FOOTER //
// ./components/Batch/ManageBatch/ManageBatch.js